import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/pause.svg';

export const IconPause = createIconComponent(Icon);
